import { PropTypes } from 'prop-types';
import React from 'react';

import ArrowLinkAngled from '../../assets/svg/arrow-link-angled.svg';
import Link from '../Link';

const ListPrimary = ({ body, listTitle }) => {
  return (
    <div className="flex flex-col">
      <p className="pb-4 border-b stink-footnote text-slate border-smoke">
        {listTitle}
      </p>
      {body.map(({ id, title, url }) => {
        return (
          <Link
            key={id}
            className="flex justify-between py-2 border-b border-smoke text-hover"
            to={url}
          >
            <span className="flex-1 stink-footnote">{title}</span>
            <ArrowLinkAngled className="w-3 h-full mr-3" />
          </Link>
        );
      })}
    </div>
  );
};

ListPrimary.propTypes = {
  body: PropTypes.array,
  listTitle: PropTypes.string,
};

export default ListPrimary;
